export default __webpack_public_path__ + "static/media/MusicH2.e99d7c14.png";